import { ActionTree } from 'vuex';
import { UsersState } from './types';
import { RootState } from '@/types';
import { userService } from '@/services/user.services';


export const actions: ActionTree<UsersState, RootState> = {
    get({ commit }, { page = 1, perPage = 10, search = '', archived = false, hide = false }): any {
        commit('setLoading');
        userService.index(page, perPage, search, archived, hide)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
    create({ dispatch }, { user }): any {
        userService.create(user).then(() => {
            dispatch('get', {});
        });
    },
    setStatus({ dispatch }, { user, active = true, admin = false, hide = false }): any {
        user.active = active;
        user.admin = admin;
        user.hide = hide;
        userService.update(user).then(() => {
            dispatch('get', {});
        });
    },
};
